<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Large file sizes</h3>
    <table>
      <tbody>
        <tr>
          <td>
            <p class="NOTE">
              If you are having trouble uploading an access Database or an excel file, check the size of the file. The larger the file size, the
              longer it takes to upload. Even on a broadband connection, a file of 2 or 3 megabytes can take a couple of minutes to upload.
            </p>
            <p class="note">
              To check the file size, open Windows Explorer. If you don't know how to do this, try "right-clicking" (clicking with the mouse button on
              the right side of the mouse) on the "my Computer" icon and choosing "explore" from the context menu that pops-up.
            </p>
            <div></div>
            <p class="note">
              Next, find the file. Hint: many programs save files in the "my documents" folder. Once you have found the file, "right-click" on it and
              choose "properties". You should see a dialog box like this one.
            </p>
            <div></div>
            <p class="note">You can see the size of the file listed in <em>KB</em>. 1024 KB is equal to 1 mebabyte.</p>
            <p class="note">
              If you are working with an access database and the file seems to be larger than you expected, you might try
              <a class="text" href="/admin-points-faq/access-compact">Compacting</a> it using the Access program.
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'LargeFiles',
};
</script>
<style scoped>
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
